import inRegions from '@segment/in-regions'
import cookies from 'js-cookie'
import React from 'react'

import {
  ConsentManager,
  openConsentManager,
  loadPreferences,
  onPreferencesSaved,
} from '~/components/ConsentBuilder'
import { CloseBehavior } from '~/components/ConsentBuilder/consent-manager/container'
import { Preferences } from '~/components/ConsentBuilder/types'
import RichText, { RichTextBlock } from '~/components/RichText'
import getHtmlSerializer from '~/components/RichText/get-html-serializer'

export interface ConsentProps {
  bannerContent?: RichTextBlock[]
  acceptButton?: RichTextBlock[]
  manageButton?: RichTextBlock[]
  refuseButton?: RichTextBlock[]
  preferencesDialogTitle?: RichTextBlock[]
  preferencesDialogContent?: RichTextBlock[]
  cancelDialogTitle?: RichTextBlock[]
  cancelDialogContent?: RichTextBlock[]
}

export default function Consent({
  bannerContent,
  acceptButton,
  manageButton,
  refuseButton,
  preferencesDialogTitle,
  preferencesDialogContent,
  cancelDialogTitle,
  cancelDialogContent,
}: ConsentProps) {
  const [prefs, updatePrefs] = React.useState<Preferences>(loadPreferences())

  const cleanup = onPreferencesSaved((preferences) => {
    updatePrefs(preferences)
  })

  React.useEffect(() => {
    return () => {
      cleanup()
    }
  })

  if (typeof window === 'undefined') return null

  const inCA = inRegions(['CA'])
  const inEU = inRegions(['EU'])

  const shouldRequireConsent = inRegions(['CA', 'EU'])
  const caDefaultPreferences = {
    advertising: false,
    marketingAndAnalytics: true,
    functional: true,
  }
  const euDefaultPreferences = {
    advertising: false,
    marketingAndAnalytics: false,
    functional: false,
  }

  const closeBehavior = inCA()
    ? (_categories) => caDefaultPreferences
    : inEU()
    ? CloseBehavior.DENY
    : CloseBehavior.ACCEPT

  const initialPreferences = inCA()
    ? caDefaultPreferences
    : inEU()
    ? euDefaultPreferences
    : undefined

  return (
    <>
      <ConsentManager
        writeKey={process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY}
        bannerContent={<RichText render={bannerContent} />}
        acceptButton={acceptButton}
        manageButton={manageButton}
        refuseButton={refuseButton}
        preferencesDialogTitle={<RichText render={preferencesDialogTitle} />}
        preferencesDialogContent={
          <RichText render={preferencesDialogContent} />
        }
        cancelDialogTitle={<RichText render={cancelDialogTitle} />}
        cancelDialogContent={<RichText render={cancelDialogContent} />}
        closeBehavior={closeBehavior}
        shouldRequireConsent={shouldRequireConsent}
        initialPreferences={initialPreferences}
      />
    </>
  )
}
